import { apiGet, apiPost, apiPut, apiDelete } from "./client.js";

export const listSubTenants = (orgId, tenantId) =>
  apiGet(`/api/v1/orgs/${orgId}/tenants/${tenantId}/subtenants`).then((d) => d.subTenants || []);
export const getSubTenant = (orgId, tenantId, id) =>
  apiGet(`/api/v1/orgs/${orgId}/tenants/${tenantId}/subtenants/${id}`);
export const createSubTenant = (orgId, tenantId, data) =>
  apiPost(`/api/v1/orgs/${orgId}/tenants/${tenantId}/subtenants`, data);
export const updateSubTenant = (orgId, tenantId, id, data) =>
  apiPut(`/api/v1/orgs/${orgId}/tenants/${tenantId}/subtenants/${id}`, data);
export const deleteSubTenant = (orgId, tenantId, id) =>
  apiDelete(`/api/v1/orgs/${orgId}/tenants/${tenantId}/subtenants/${id}`);
